export const alocacao = {
  titulo: 'Alocações',
  descricao:
    'Percentual de profissionais alocados em projetos, com rateio de custo BR/US. Quem tem mais de uma alocação fica em Consultas > Multialocados.',
  nova: 'Nova alocação',
  filtros: {
    profissional: 'Profissional',
    projeto: 'Projeto',
    contrato: 'Contrato',
    cliente: 'Cliente',
    anotacoes: 'Anotações',
    anotacoesPlaceholder: 'Buscar por anotações…',
    buscarPlaceholder: 'Buscar por nome ou código…',
    profissionaisPlaceholder: 'Selecione um ou mais profissionais…',
    buscando: 'Buscando…',
    semResultados: 'Nenhum resultado encontrado.',
    limpar: 'Limpar filtros',
    limparSelecao: 'Limpar seleção',
    periodoInicio: 'Início',
    periodoFim: 'Fim',
    periodoFimHint: 'Sobreposição com o período da alocação. Vazio = do Início em diante.',
    codigoOuNomePlaceholder: 'Código ou nome…',
    nomeOuMatriculaPlaceholder: 'Nome ou matrícula…',
    avancados: 'Filtros avançados',
    aplicados: 'Filtros aplicados',
    avancadosDescricao:
      'Os campos acompanham as colunas visíveis da tabela: mostre ou esconda colunas em "Colunas" para mudar os filtros disponíveis.',
    percentualMinimo: '% alocação mínima',
    percentualMaximo: '% alocação máxima',
    contratoDoClienteHint: 'Listando só os contratos do cliente escolhido.',
    mostrandoDeTotal: 'Mostrando {{shown}} de {{total}}. Digite para refinar.',
    aplicar: 'Aplicar filtros',
    cancelar: 'Cancelar',
    totalProfissionais_one: 'Mostrando {{showing}} de {{count}} profissional',
    totalProfissionais_other: 'Mostrando {{showing}} de {{count}} profissionais',
    chips: {
      contem: '{{field}} contém "{{value}}"',
      percentualEntre: '% alocação entre {{min}} e {{max}}',
      percentualMinimo: '% alocação a partir de {{min}}',
      percentualMaximo: '% alocação até {{max}}',
      selecionado: '{{field}}: {{name}}',
      profissionais_one: 'Profissional',
      profissionais_other: 'Profissionais',
      eMais: '{{names}} e mais {{count}}',
      periodoEntre: 'Período: {{start}} a {{end}}',
      periodoDesde: 'Período: a partir de {{start}}',
      periodoAte: 'Período: até {{end}}',
      remover: 'Remover filtro: {{filter}}',
    },
  },
  tabela: {
    profissional: 'Profissional',
    projeto: 'Projeto',
    contrato: 'Contrato',
    cliente: 'Cliente',
    percAlocado: '% alocação',
    faturando: 'Faturando',
    inicio: 'Início',
    fim: 'Fim',
    unidade: 'Unidade',
    custoBrUs: 'Custo BR/US',
    perfilVenda: 'Perfil de venda',
    custoAlocado: 'Custo alocado',
    diretorConta: 'Diretor Conta',
    gerenteOperacao: 'Gerente Operação',
    gerenteProjeto: 'Gerente Projeto',
    custoMes: 'Custo mês',
    fatBrutoMes: 'Fat. bruto mês',
    fatLiquidoMes: 'Fat. líquido mês',
    ebitda: 'EBITDA %',
    acoes: 'Ações',
    acoesDaAlocacao: 'Ações da alocação em {{projeto}}',
    semTermino: 'sem término',
    fimEstimado: 'estimado',
    br: 'BR',
    us: 'US',
    itensPorPagina: 'Itens por página',
    profissionaisPorPagina: 'Profissionais por página',
  },
  colunas: {
    titulo: 'Colunas',
    visiveis: 'Colunas visíveis',
    aplicar: 'Aplicar',
    redefinir: 'Redefinir',
    nenhumaSelecionada: 'Selecione ao menos uma coluna.',
  },
  acoes: {
    visualizar: 'Visualizar',
    editar: 'Editar',
    encerrar: 'Encerrar',
  },
  estados: {
    escopoVazioTitulo: 'Nenhum projeto sob sua responsabilidade',
    escopoVazioDescricao:
      'Você ainda não é gerente, gerente de carteira ou diretor de conta em nenhum projeto. Procure o time de sistemas internos se isso não estiver correto.',
    filtroSemResultadoTitulo: 'Nenhuma alocação encontrada',
    filtroSemResultadoDescricao: 'Ajuste os filtros ou cadastre uma nova alocação.',
  },
  linhaDoTempo: {
    barra: '{{projeto}}, {{percentual}}%',
    titulo: 'Linha do tempo',
    tabela: 'Tabela',
    alternarVisao: 'Alternar entre tabela e linha do tempo',
    semResultadoDescricao: 'Ajuste os filtros ou o período para ver alocações nesta janela.',
    periodo: 'Período',
    periodoMeses_one: '{{count}} mês',
    periodoMeses_other: '{{count}} meses',
    periodoPorFiltro: 'Período definido pelos filtros de Início e Fim.',
    statusFiltro: 'Filtrar por status',
    statusLabel: 'Status',
    irParaHoje: 'Ir para hoje',
    hoje: 'Hoje',
    utilizacao: 'Utilização {{valor}}%',
    sobrealocadoValor: 'Sobrealocado +{{valor}}%',
    disponivel: 'Disponível',
    alocacoesContagem_one: '{{count}} alocação',
    alocacoesContagem_other: '{{count}} alocações',
    legenda: 'Legenda',
    legendaAtiva: 'Ativa',
    legendaFutura: 'Futura',
    legendaEncerrada: 'Encerrada',
    legendaFaturavel: 'Faturável',
    legendaNaoFaturavel: 'Não faturável',
    legendaFimEstimado: 'Fim estimado',
    legendaSobrealocado: 'Sobrealocado',
  },
  form: {
    id: 'Id',
    novaTitulo: 'Nova alocação',
    editarTitulo: 'Editar alocação',
    visualizarTitulo: 'Detalhes da alocação',
    profissional: 'Profissional',
    profissionalPlaceholder: 'Buscar por nome ou matrícula…',
    projeto: 'Projeto',
    projetoPlaceholder: 'Buscar por código ou nome…',
    projetoSemContrato: 'Escolha o contrato para ver os projetos dele.',
    contrato: 'Contrato',
    contratoPlaceholder: 'Buscar por código ou nome…',
    percAlocado: '% alocação',
    rateioCustoBr: 'Rateio de custo BR (%)',
    rateioCustoUs: 'Rateio de custo US (%)',
    rateioSomaErro: 'O rateio BR + US deve somar 100%.',
    faturando: 'Faturando',
    dtInicio: 'Início',
    dtFim: 'Fim',
    dtFimHint: 'Vazio = sem término. Último dia coberto (inclusivo).',
    fimConfirmado: 'Fim Confirmado',
    tags: 'Tags',
    tagsPlaceholder: 'Selecione as tags…',
    tagsBuscarPlaceholder: 'Buscar tag…',
    tagsSemResultado: 'Nenhuma tag encontrada.',
    tagsRemover: 'Remover tag {{nome}}',
    anotacoes: 'Anotações',
    anotacoesLimite: 'Use no máximo {{max}} caracteres.',
    alocar: 'Alocar',
    descartarTitulo: 'Descartar alterações?',
    descartarDescricao: 'O que você preencheu nesta alocação será perdido.',
    descartar: 'Descartar',
    continuarEditando: 'Continuar editando',
    perfilVenda: 'Perfil de venda',
    perfilVendaPlaceholder: 'Selecione o perfil…',
    perfilVendaBuscar: 'Buscar perfil…',
    perfilVendaNenhum: 'Sem perfil de venda',
    perfilVendaOpcao: '{{versao}} - {{nome}} - Preço: {{preco}}',
    perfilVendaSemContrato: 'Escolha o contrato para ver os perfis dele.',
    custoMes: 'Custo mês',
    custoMesHint: 'Vem do contrato do profissional; altere só para customizar.',
    custoAlocado: 'Custo alocado',
    precoHora: 'Preço hora',
    horasVendidas: 'Horas vendidas',
    fatBrutoMes: 'Fat. bruto mês',
    fatLiquidoMes: 'Fat. líquido mês',
    projetoSemFaturamento:
      'Projeto de pool ou interno não fatura: perfil de venda, preço, horas e faturamento não se aplicam. O custo continua valendo.',
    avisado: 'Avisado',
    avisadoEm: 'Avisado em',
    numeroDias: 'Número de dias',
    fimPeloAviso: 'O fim é calculado: data do aviso + número de dias. Ainda dá para alterá-lo.',
    bloqueioTitulo: 'Não é possível salvar',
    avisoTitulo: 'Atenção',
  },
  encerrar: {
    titulo: 'Encerrar alocação',
    descricao:
      'Encerrar a alocação de {{profissional}} em {{projeto}}. A linha não é apagada — só recebe uma data de fim.',
    dtFim: 'Último dia coberto',
    confirmar: 'Encerrar em {{data}}',
  },
  exportacao: {
    sucesso: 'Arquivo exportado.',
    botao: 'Exportar',
    titulo: 'Exportar alocações',
    descricao: 'Filtros, buscas, ordenação e colunas visíveis da tabela valem no arquivo.',
    conteudo: 'Conteúdo',
    todasPaginas_one: 'Todas as páginas ({{count}} profissional)',
    todasPaginas_other: 'Todas as páginas ({{count}} profissionais)',
    paginaAtual_one: 'Só esta página ({{count}} profissional)',
    paginaAtual_other: 'Só esta página ({{count}} profissionais)',
    todasPaginasRegistros_one: 'Todas as páginas ({{count}} registro)',
    todasPaginasRegistros_other: 'Todas as páginas ({{count}} registros)',
    paginaAtualRegistros_one: 'Só esta página ({{count}} registro)',
    paginaAtualRegistros_other: 'Só esta página ({{count}} registros)',
    formato: 'Formato',
    excel: 'Excel (.xlsx)',
    csv: 'CSV (.csv)',
    nomeArquivo: 'alocacoes',
  },
  lote: {
    selecionados_one: '{{count}} alocação selecionada',
    selecionados_other: '{{count}} alocações selecionadas',
    gerenciarTags: 'Gerenciar tags',
    limparSelecao: 'Limpar seleção',
    selecionarPagina: 'Selecionar todas as alocações da página',
    selecionarAlocacao: 'Selecionar a alocação {{projeto}}',
    titulo: 'Gerenciar tags em lote',
    descricao_one: 'Vale para a {{count}} alocação selecionada. As outras tags dela não mudam.',
    descricao_other:
      'Vale para as {{count}} alocações selecionadas. As outras tags de cada uma não mudam.',
    adicionar: 'Adicionar tags',
    adicionarPlaceholder: 'Tags a aplicar…',
    remover: 'Remover tags',
    removerPlaceholder: 'Tags a tirar…',
    removerSemResultado: 'As alocações selecionadas não têm essa tag.',
    conflito: 'Uma tag não pode ser adicionada e removida ao mesmo tempo.',
    aplicar: 'Aplicar',
    sucesso_one: 'Tags atualizadas em {{count}} alocação.',
    sucesso_other: 'Tags atualizadas em {{count}} alocações.',
    ignoradas_one: '{{count}} alocação não foi alterada (fora do seu escopo ou já removida).',
    ignoradas_other:
      '{{count}} alocações não foram alteradas (fora do seu escopo ou já removidas).',
  },
  toasts: {
    criarSucesso: 'Alocação criada com sucesso.',
    atualizarSucesso: 'Alocação atualizada com sucesso.',
    encerrarSucesso: 'Alocação encerrada com sucesso.',
    erro: 'Não foi possível concluir a operação.',
  },
  erros: {
    invalidPercentage: 'O percentual de alocação deve estar entre 1 e 100.',
    invalidCostShare: 'O rateio de custo BR + US deve somar 100%.',
    endDateBeforeStartDate: 'A data de fim não pode ser anterior à data de início.',
    overlappingPeriod: 'Já existe alocação deste profissional neste projeto no período informado.',
    projectOutOfScope: 'Este projeto não está no seu escopo.',
    projectNotAllocatable: 'Este projeto não aceita novas alocações.',
    professionalHasNoActiveContract: 'Este profissional não tem contrato ativo.',
    sumAbove100: 'A soma das alocações deste profissional fica em {{total}}%.',
    unconfirmedWarnings: 'Os avisos mudaram — confira antes de salvar novamente.',
    allocationAlreadyClosed: 'Esta alocação já está encerrada.',
    allocationNotFound: 'Esta alocação não existe mais. Atualize a página.',
    noAxiisIdentity: 'Sua conta não tem cadastro correspondente no AXIIS.',
    inactiveAxiisIdentity: 'Seu cadastro no AXIIS está inativo.',
    ambiguousAxiisIdentity: 'Seu cadastro no AXIIS está ambíguo.',
    noAxiisIdentityGuidance: 'Procure o time de sistemas internos para resolver.',
    exportTooLarge: 'Linhas demais para exportar. Refine os filtros e tente de novo.',
    unknown: 'Ocorreu um erro inesperado.',
    salesProfileNotAllocatable: 'O perfil de venda não é do contrato do projeto ou está inativo.',
    invalidFinancialValue: 'Custo, preço e horas não podem ser negativos.',
    professionalOutOfScope:
      'Este profissional não está alocado em nenhum projeto seu. Peça a um administrador para alocá-lo.',
    professionalNotAllocatable: 'Este profissional não pode ser alocado.',
    tagNotFound: 'Esta tag não existe mais. Atualize a página.',
    tagNameTaken: 'Já existe uma tag com este nome.',
    tagInactive: 'Uma das tags está inativa e não pode ser aplicada.',
    invalidTagBatch:
      'Escolha ao menos uma tag para adicionar ou remover, sem repetir a mesma nas duas listas.',
    tagInUse: 'A tag está vinculada a alocações e não pode ser excluída. Desative-a.',
    invalidManager: 'Este gestor não está mais ativo. Atualize a página e escolha outro.',
    projectNotFound: 'Este projeto não existe mais. Atualize a página.',
  },
  consultas: {
    dataReferencia: 'Situação em',
    total_one: '{{count}} registro',
    total_other: '{{count}} registros',
    colunas: {
      matricula: 'Matrícula',
      profissional: 'Profissional',
      perfil: 'Perfil',
      ultimaAlocacao: 'Última alocação',
      responsavel: 'Responsável',
      poolDesde: 'Pool desde',
      avisado: 'Avisado',
      avisadoEm: 'Avisado em',
      numeroDias: 'Nº de dias',
      moeda: 'Moeda',
      fimAlocacao: 'Fim da alocação',
      tipo: 'Tipo',
      situacao: 'Situação',
    },
    filtros: {
      nomeOuMatriculaPlaceholder: 'Nome ou matrícula…',
      todos: 'Todos',
      avancadosDescricao:
        'Filtre por um ou mais profissionais, tipo de contrato, perfil ou situação.',
    },
    pool: {
      titulo: 'Pool',
      totalCustoAlocado: 'Total do custo alocado',
      descricao: 'Profissionais alocados em projetos de pool no dia escolhido.',
      dataReferenciaDica: 'Mostra quem está no pool nesse dia. Hoje por padrão.',
      editarAlocacaoDe: 'Editar a alocação de {{nome}}',
      vazioTitulo: 'Ninguém no pool em {{date}}',
      vazioDescricao: 'Nenhuma alocação vigente nessa data em projeto marcado como pool.',
      filtrosDescricao:
        'Filtre por um ou mais profissionais, perfil, projeto, faturamento, aviso, anotações ou tags.',
      filtroSemResultadoTitulo: 'Nenhuma alocação encontrada',
      filtroSemResultadoDescricao: 'Ajuste ou limpe os filtros para ver quem está no pool.',
      exportarTitulo: 'Exportar Pool',
      nomeArquivo: 'pool',
    },
    semAlocacao: {
      titulo: 'Sem alocação',
      descricao:
        'Contratos não encerrados, suspensos nem cancelados, sem alocação vigente no dia escolhido.',
      dataReferenciaDica: 'Mostra quem está sem alocação nesse dia. Hoje por padrão.',
      total_one: 'Mostrando {{showing}} de {{count}} contrato sem alocação',
      total_other: 'Mostrando {{showing}} de {{count}} contratos sem alocação',
      vazioTitulo: 'Todos os contratos têm alocação em {{date}}',
      vazioDescricao: 'Todo mundo está alocado em algum projeto ou no pool.',
      filtroSemResultadoTitulo: 'Nenhum contrato encontrado',
      filtroSemResultadoDescricao: 'Ajuste ou limpe os filtros para ver os contratos sem alocação.',
      exportarTitulo: 'Exportar Sem alocação',
      nomeArquivo: 'sem-alocacao',
    },
    multialocados: {
      titulo: 'Multialocados',
      descricao:
        'Profissionais com mais de uma alocação vigente hoje, com as alocações agrupadas por profissional.',
      pesquisadosEmMultialocados_one:
        '{{count}} profissional pesquisado tem mais de uma alocação e aparece em Multialocados.',
      pesquisadosEmMultialocados_other:
        '{{count}} profissionais pesquisados têm mais de uma alocação e aparecem em Multialocados.',
      pesquisadosEmAlocacoes_one:
        '{{count}} profissional pesquisado tem só uma alocação e aparece em Alocações.',
      pesquisadosEmAlocacoes_other:
        '{{count}} profissionais pesquisados têm só uma alocação e aparecem em Alocações.',
      verEmMultialocados: 'Ver em Multialocados',
      verEmAlocacoes: 'Ver em Alocações',
      pesquisaAbertaEmMultialocados:
        'Quem você pesquisou tem mais de uma alocação, então a pesquisa abriu em Multialocados.',
      pesquisaAbertaEmAlocacoes:
        'Quem você pesquisou tem só uma alocação, então a pesquisa abriu em Alocações.',
    },
    sintese: {
      titulo: 'Síntese de alocações',
      descricao:
        'Projeção de headcount por centro de custo nas próximas semanas, a partir das datas das alocações vigentes.',
      dataReferenciaDica: 'Base da projeção. Hoje por padrão.',
      horizonte: 'Horizonte',
      horizonteSemanas_one: '{{count}} semana',
      horizonteSemanas_other: '{{count}} semanas',
      centroCusto: 'Centro de custo',
      secaoBR: 'NT BR',
      secaoUS: 'NT US',
      total: 'Total',
      semanaDe: 'Semana de {{date}}',
      variacao: 'Variação de headcount em relação à semana anterior',
      vazioTitulo: 'Nenhuma alocação para projetar em {{date}}',
      vazioDescricao: 'Não há alocações vigentes para montar a projeção por centro de custo.',
      exportarTitulo: 'Exportar síntese',
      exportarDescricao: 'A data de referência e o horizonte escolhidos valem no arquivo.',
      nomeArquivo: 'sintese-de-alocacoes',
    },
    conferenciaPercentual: {
      titulo: 'Conferência de percentual de alocação',
      descricao:
        'Profissionais cuja soma diária de alocação não fecha em 100% em algum dia do período.',
      periodoAplicado: 'Período aplicado: {{periodo}}',
      dicaPeriodo: 'Comparação por período. Padrão: mês corrente. Máximo 12 meses.',
      inicio: 'Início',
      fim: 'Fim',
      bucket: {
        todos: 'Todos',
        abaixo: 'Abaixo de 100%',
        cemPorcento: '100%',
        acima: 'Acima de 100%',
        zero: 'Em 0%',
      },
      incluirZero: 'Incluir profissionais em 0%',
      cards: {
        abaixoTitulo: 'Abaixo de 100%',
        abaixoDescricao: 'Capacidade ociosa',
        cemTitulo: 'Em 100%',
        cemDescricao: 'Alocação fechada',
        acimaTitulo: 'Acima de 100%',
        acimaDescricao: 'Sobrealocação',
        zeroTitulo: 'Em 0%',
        zeroDescricao: 'Sem alocação no período',
        total: '{{count}} profissionais no período',
      },
      colunas: {
        matricula: 'Matrícula',
        profissional: 'Profissional',
        unidade: 'Unidade',
        tipoContrato: 'Tipo de contrato',
        situacaoContrato: 'Situação',
        minimo: 'Mín %',
        maximo: 'Máx %',
        media: 'Média %',
        diasAbaixo: 'Dias abaixo',
        diasEm100: 'Dias em 100%',
        diasAcima: 'Dias acima',
        classificacao: 'Classificação',
      },
      classificacao: {
        zero: '0%',
        below: 'Abaixo',
        at100: '100%',
        above: 'Acima',
      },
      detalhes: {
        tituloAdmin: 'Alocações no período',
        gestorOculto:
          '{{count}} alocação em projeto fora do seu escopo não aparece no detalhe (regra do sistema). Entra na soma mostrada acima.',
        gestorOcultoPlural:
          '{{count}} alocações em projetos fora do seu escopo não aparecem no detalhe (regra do sistema). Entram na soma mostrada acima.',
      },
      filtros: {
        titulo: 'Filtros avançados',
        descricao: 'Aplique os filtros desta consulta.',
        profissional: 'Profissional',
        unidade: 'Unidade',
        tipoContrato: 'Tipo de contrato',
        situacaoContrato: 'Situação do contrato',
        faixaEntre: '{{field}} entre {{min}} e {{max}}',
        faixaMinima: '{{field}} a partir de {{min}}',
        faixaMaxima: '{{field}} até {{max}}',
      },
      vazioTitulo: 'Nenhum desvio no período',
      vazioDescricao: 'Ninguém saiu de 100% nesse recorte. Experimente outro período ou situação.',
      exportarTitulo: 'Exportar conferência',
      exportarDescricao: 'O período e os filtros atuais valem no arquivo.',
      nomeArquivo: 'conferencia-percentual',
    },
  },
} as const;
